import { useEffect } from "react";
import { useInternalAdmin } from "@/hooks/useInternalAdmin";
import { setScanAdmin, emailIsScanAdmin } from "@/lib/scan/scanAdmin";

/**
 * Binds the on-device-scan debug gate to the signed-in account. Pushes the
 * "is andy@photohawk.io" verdict into the plain scan modules (scanUi.ts, worker
 * config) so non-React code can gate on it synchronously.
 *
 * It renders NOTHING. The old always-on debug surface (the black/green metrics HUD
 * and the right-edge "scan levers" drawer) is gone — those persistent overlays were
 * unwanted. The granular scan overrides now live only in the uploader Settings gear
 * (ScanSettingsControls, andy-only), on demand, with console logging behind
 * ph_scan_debug. Mounted browser-only (inside ClientOnly).
 */
const ScanAdminBinder = () => {
  const { email } = useInternalAdmin();
  const admin = emailIsScanAdmin(email);
  useEffect(() => {
    setScanAdmin(admin);
  }, [admin]);
  return null;
};

export default ScanAdminBinder;
